import React from "react";
import PropTypes from "prop-types";
import "./GridCheckbox.scss";

const GridCheckbox = ({
  name = "",
  label,
  checked,
  onChange,
  disabled,
  dataField,
  cssClass = "",
}) => {

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;
    if (onChange) {
      onChange(dataField, newValue);
    }
  };

  return (
    <div className={cssClass}>
      <div className="checkbox">
        <input
          id={name}
          name={name}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          className="form-checkbox"
          onChange={handleCheckboxChange}
        />
        <label
          htmlFor={name}
          className={"checkbox-label checkbox-disable"}
        >{label || ""}</label>
      </div>
    </div>
  );
};

GridCheckbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired, // Ensure label is a required prop
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  dataField: PropTypes.string,
  cssClass: PropTypes.string,
};

export default GridCheckbox;
